import type { FunnelAnswers, FunnelMeta } from "./config";

// It's only for debugging purposes. It should be removed after the issue is fixed.
// See: https://helloflare.atlassian.net/browse/F20-1403
export function isLeadScoreMissingInAnswersButPresentInMeta(
  answers: FunnelAnswers,
  meta: FunnelMeta,
) {
  if (typeof answers.leadScore === "number") {
    return false;
  }

  const andrewModelFromMeta = meta.models?.find(
    (model) => model.name === "Andrew",
  );

  return !answers.leadScore && !!andrewModelFromMeta;
}
